/** @format */

import styled, { css } from "styled-components";
import { BaseColor } from "../../../theme/maps/Colors";
import { C, L } from "../../../theme/maps/StatiPresenze";

/** Stessa intestazione, barra degli strumenti e pagina dei Turni. */
export { BarraStrumenti, Intestazione, Pagina } from "../ViewTurniSettimana/styles";

export const COLONNE_GIORNATA = "260px minmax(560px, 1fr) 150px 230px";

/** Chip, pillole, bandierine e pulsanti piccoli: comuni a tutte le parti della vista. */
const elementiComuni = css`
  .chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    height: 26px;
    padding: 0 9px;
    border: 1px solid transparent;
    border-radius: 13px;
    font: inherit;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    cursor: pointer;
  }
  .chip.rosso {
    background: ${L.anomalia.fondo};
    color: ${L.anomalia.testo};
  }
  .chip.rosso:hover {
    border-color: ${L.anomalia.bordo};
  }
  .chip.ambra {
    background: ${L.avviso.fondo};
    color: ${L.avviso.testo};
  }
  .chip.ambra:hover {
    border-color: ${L.avviso.bordo};
  }
  .chip.verde {
    background: ${C.inCorso.fondo};
    color: ${C.inCorso.testo};
    cursor: default;
  }
  .chip.grigio {
    background: #eceef3;
    color: #3a4160;
  }
  .pillola {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }
  .pillola.grigio {
    background: #eceef3;
    color: #41475e;
  }
  .pillola.verde {
    background: ${C.inCorso.fondo};
    color: ${C.inCorso.testo};
  }
  .pillola.rosso {
    background: ${L.anomalia.fondo};
    color: ${L.anomalia.testo};
  }
  .pillola.blu {
    background: ${C.daSvolgere.fondo};
    color: ${C.daSvolgere.testo};
  }
  .pillola.viola {
    background: ${L.straordinario.fondo};
    color: ${L.straordinario.testo};
  }
  .pillola.ambra {
    background: ${L.avviso.fondo};
    color: ${L.avviso.testo};
  }
  .bandierina {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 24px;
    padding: 0 10px;
    border: 0;
    border-radius: 12px;
    font: inherit;
    font-size: 12px;
    font-weight: 700;
  }
  button.bandierina {
    cursor: pointer;
  }
  .bandierina.verde {
    background: ${C.inCorso.fondo};
    color: ${C.inCorso.testo};
  }
  .bandierina.grigio {
    background: #eceef3;
    color: #41475e;
  }
  .bandierina.rosso {
    background: ${L.anomalia.fondo};
    color: ${L.anomalia.testo};
  }
  .bandierina.ambra {
    background: ${L.avviso.fondo};
    color: ${L.avviso.testo};
  }
  .bandierina.festa {
    background: ${C.festa.fondo};
    color: ${C.festa.testo};
  }
  .attenuato {
    color: ${C.testoSecondario};
  }
  .numeri {
    font-variant-numeric: tabular-nums;
  }
`;

export const AvatarStile = styled.span`
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  background: #e4e7f3;
  color: #3a4580;
  font-size: 11.5px;
  font-weight: 700;

  &.grande {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Schede = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  border-bottom: 1px solid #dde0e9;

  button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 44px;
    margin-bottom: -1px;
    padding: 0 14px;
    border: 0;
    border-bottom: 3px solid transparent;
    background: transparent;
    font: inherit;
    font-size: 14.5px;
    font-weight: 700;
    color: #4a5170;
    cursor: pointer;
  }
  button:hover {
    color: #2f3a78;
  }
  button[aria-current="page"] {
    color: #2f3a78;
    border-bottom-color: ${BaseColor};
  }
  .conteggio {
    display: inline-grid;
    place-items: center;
    min-width: 20px;
    height: 18px;
    padding: 0 6px;
    border-radius: 9px;
    font-size: 12px;
    background: #fbe1e7;
    color: ${C.anomalia.testo};
  }
`;

/** Riga in più della barra: aggiornamento e giorno bloccato. */
export const Stato = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: ${C.testoSecondario};
`;

export const Settimana = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 6px;

  button {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
    padding: 7px 10px;
    border: 1px solid ${C.linea};
    border-radius: 9px;
    background: #fff;
    font: inherit;
    text-align: left;
    cursor: pointer;
  }
  button:hover {
    border-color: #a9b0d6;
  }
  button[aria-pressed="true"] {
    border-color: ${BaseColor};
    background: ${C.oggi};
    box-shadow: inset 0 -3px 0 ${BaseColor};
  }
  .alto {
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
    text-transform: capitalize;
  }
  .alto b {
    font-size: 16px;
    color: ${C.testo};
  }
  .sotto {
    overflow: hidden;
    font-size: 12px;
    font-weight: 700;
    color: #8a90a3;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .sotto.rosso {
    color: ${C.anomalia.testo};
  }
  .sotto.verde {
    color: ${C.inLinea};
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

/** Blocchi della linea oraria: righe della Giornata e linea del pannello. */
export const lineaOraria = css`
  .linea {
    position: relative;
    height: 62px;
    background-image: linear-gradient(to right, ${C.lineaLeggera} 1px, transparent 1px);
  }
  .linea.festa {
    background-color: ${L.festa.fondo};
  }
  .linea.compatta {
    height: 54px;
  }
  .blocco {
    position: absolute;
    display: flex;
    align-items: center;
    overflow: hidden;
    border: 1px solid;
    font: inherit;
    font-size: 11.5px;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
    font-variant-numeric: tabular-nums;
    cursor: pointer;
  }
  .blocco:focus-visible {
    outline: 2px solid ${BaseColor};
    outline-offset: 1px;
  }
  .turno {
    top: 6px;
    bottom: 6px;
    align-items: flex-start;
    padding: 3px 7px;
    border-style: dashed;
    border-radius: 8px;
    background: ${L.turno.fondo};
    border-color: ${L.turno.bordo};
    color: ${L.turno.testo};
  }
  .turno:hover {
    border-color: #7f89c4;
  }
  .turno.non-timbrato {
    background: ${L.nonTimbrato.fondo};
    border-color: ${L.nonTimbrato.bordo};
    color: ${L.nonTimbrato.testo};
  }
  .turno.coperto {
    background: ${L.coperto.fondo};
    border-color: ${L.coperto.bordo};
    color: ${L.coperto.testo};
  }
  .permesso {
    top: 6px;
    bottom: 6px;
    align-items: flex-start;
    padding: 3px 7px;
    border-radius: 8px;
    color: ${C.testo};
    background-image: repeating-linear-gradient(
      135deg,
      rgba(255, 255, 255, 0) 0 6px,
      rgba(255, 255, 255, 0.7) 6px 9px
    );
  }
  .permesso.in-attesa {
    border-style: dashed;
  }
  .presenza {
    z-index: 2;
    bottom: 11px;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 25px;
    padding: 0 7px;
    border-radius: 6px;
    font-size: 12.5px;
  }
  .linea.compatta .presenza {
    bottom: 8px;
    height: 22px;
    font-size: 11.5px;
  }
  .presenza.chiusa {
    background: ${L.chiusa.fondo};
    border-color: ${L.chiusa.bordo};
    color: ${L.chiusa.testo};
  }
  .presenza.aperta {
    background: ${L.aperta.fondo};
    border-color: ${L.aperta.bordo};
    color: ${L.aperta.testo};
  }
  .presenza.anomalia {
    background: ${L.anomalia.fondo};
    border-color: ${L.anomalia.bordo};
    color: ${L.anomalia.testo};
  }
  .presenza.straordinario {
    background: ${L.straordinario.fondo};
    border-color: ${L.straordinario.bordo};
    color: ${L.straordinario.testo};
  }
  .presenza.avviso {
    background: ${L.avviso.fondo};
    border-color: ${L.avviso.bordo};
    color: ${L.avviso.testo};
  }
  .presenza:hover {
    filter: brightness(0.97);
  }
  .punto-vivo {
    flex-shrink: 0;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${L.aperta.punto};
  }
  .giornata-intera {
    position: absolute;
    top: 13px;
    right: 10px;
    bottom: 13px;
    left: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 12px;
    border: 1px solid;
    border-radius: 8px;
    font: inherit;
    font-size: 13px;
    font-weight: 700;
    color: ${C.testo};
    text-align: left;
    cursor: pointer;
  }
  .giornata-intera.in-attesa {
    border-style: dashed;
  }
  .giornata-intera.riposo {
    background: ${L.riposo.fondo};
    border-color: ${L.riposo.bordo};
    color: ${L.riposo.testo};
  }
  .giornata-intera:hover {
    box-shadow: 0 0 0 2px rgba(71, 84, 155, 0.25);
  }
  .pallino {
    flex-shrink: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .fuori {
    position: absolute;
    z-index: 2;
    top: 50%;
    padding: 1px 6px;
    border: 1px solid ${C.linea};
    border-radius: 6px;
    background: #fff;
    font-size: 11px;
    font-weight: 700;
    color: ${C.testoSecondario};
    transform: translateY(-50%);
    white-space: nowrap;
    cursor: pointer;
  }
  .fuori.sinistra {
    left: 2px;
  }
  .fuori.destra {
    right: 2px;
  }
  .adesso {
    position: absolute;
    z-index: 3;
    top: 0;
    bottom: 0;
    width: 2px;
    margin-left: -1px;
    background: ${L.adesso};
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const GrigliaGiornata = styled.div`
  ${elementiComuni}
  ${lineaOraria}
  position: relative;
  overflow: auto;
  max-height: max(420px, calc(100vh - 330px));
  background: #fff;
  border: 1px solid ${C.linea};
  border-radius: 12px;

  .contenuto {
    min-width: 1200px;
  }
  .riga {
    display: grid;
    grid-template-columns: ${COLONNE_GIORNATA};
  }
  .riga.testata {
    position: sticky;
    z-index: 6;
    top: 0;
    background: #fff;
    border-bottom: 1px solid ${C.linea};
  }
  .col-nome {
    position: sticky;
    z-index: 4;
    left: 0;
    min-width: 0;
    background: #fff;
    border-right: 1px solid ${C.linea};
  }
  .testata .col-nome,
  .testata .col-cella {
    display: flex;
    align-items: flex-end;
    padding: 12px 14px;
    font-size: 13px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .testata .col-cella {
    border-left: 1px solid ${C.lineaLeggera};
  }
  .asse {
    position: relative;
    height: 46px;
  }
  .ora-asse {
    position: absolute;
    bottom: 9px;
    transform: translateX(-50%);
    font-size: 12.5px;
    font-weight: 700;
    color: #4a5170;
    font-variant-numeric: tabular-nums;
  }
  .ora-asse.prima {
    padding-left: 4px;
    transform: none;
  }
  .ora-asse.ultima {
    padding-right: 4px;
    transform: translateX(-100%);
  }
  .etichetta-adesso {
    position: absolute;
    top: 3px;
    padding: 1px 6px;
    border-radius: 5px;
    background: ${C.testo};
    font-size: 11.5px;
    font-weight: 700;
    color: #fff;
    transform: translateX(-50%);
    font-variant-numeric: tabular-nums;
  }
  .riga.gruppo,
  .riga.reparto {
    background: ${C.fondoGruppo};
    border-bottom: 1px solid ${C.linea};
  }
  .riga.gruppo .col-nome,
  .riga.reparto .col-nome {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    padding: 10px 12px;
    background: ${C.fondoGruppo};
  }
  .riga.reparto .col-nome {
    padding-left: 34px;
  }
  .apri-gruppo {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: -4px;
    padding: 4px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    font: inherit;
    font-size: 15px;
    font-weight: 700;
    color: ${C.testo};
    text-align: left;
    cursor: pointer;
  }
  .apri-gruppo .freccia {
    color: ${C.testoSecondario};
    transition: transform 0.15s;
  }
  .apri-gruppo .freccia.aperta {
    transform: rotate(90deg);
  }
  .nome-reparto {
    font-size: 14px;
    font-weight: 700;
  }
  .conta-persone {
    padding-left: 24px;
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .riga.reparto .conta-persone {
    padding-left: 0;
  }
  .centro-gruppo {
    grid-column: span 3;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 0 14px;
  }
  .riga.persona {
    border-bottom: 1px solid ${C.lineaLeggera};
  }
  .riga.persona:hover .col-nome {
    background: #fafbfe;
  }
  .nome-persona {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 10px 8px 12px;
  }
  .apri-persona {
    display: flex;
    flex: 1;
    align-items: center;
    gap: 10px;
    min-width: 0;
    padding: 4px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    font: inherit;
    color: inherit;
    text-align: left;
    cursor: pointer;
  }
  .apri-persona:hover .nome {
    color: #2f3a78;
    text-decoration: underline;
  }
  .nome-stato {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .nome {
    overflow: hidden;
    font-size: 14px;
    font-weight: 700;
    color: ${C.testo};
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .stato {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    overflow: hidden;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .stato::before {
    content: "";
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
  }
  .stato.live {
    color: ${C.inLinea};
  }
  .stato.done,
  .stato.abs {
    color: ${C.testoSecondario};
  }
  .stato.anom {
    color: ${C.anomalia.testo};
  }
  .stato.todo {
    color: #2f3a78;
  }
  .stato.rest {
    color: ${C.riposo.testo};
  }
  .etichetta {
    flex-shrink: 0;
    padding: 2px 6px;
    border-radius: 6px;
    background: #eef0f8;
    font-size: 11px;
    font-weight: 700;
    color: #3a4160;
    white-space: nowrap;
  }
  .col-ore {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    padding: 10px 14px;
    border-left: 1px solid ${C.lineaLeggera};
  }
  .ore {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0 6px;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
  .ore strong {
    font-size: 15px;
  }
  .ore span {
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .barra {
    height: 5px;
    overflow: hidden;
    border-radius: 3px;
    background: ${C.barra.traccia};
  }
  .barra span {
    display: block;
    height: 100%;
    border-radius: 3px;
    background: ${C.barra.sotto};
  }
  .barra span.piena {
    background: ${C.barra.inLinea};
  }
  .col-gestire {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    gap: 5px;
    padding: 8px 12px;
    border-left: 1px solid ${C.lineaLeggera};
  }
  .niente {
    font-size: 12.5px;
    font-weight: 600;
    color: #8a90a3;
  }
  .vuoto {
    position: sticky;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    max-width: 640px;
    padding: 28px 20px;
  }

  @media (prefers-reduced-motion: reduce) {
    .apri-gruppo .freccia {
      transition: none;
    }
  }
`;

export const LegendaPresenze = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid ${C.linea};
  border-radius: 12px;

  .riga-legenda {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 16px;
  }
  .titolo {
    flex-shrink: 0;
    width: 104px;
    font-size: 12.5px;
    font-weight: 700;
    color: ${C.testo};
  }
  .voci {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 18px;
    min-width: 0;
    font-size: 12.5px;
    font-weight: 600;
    color: #4a5170;
  }
  .voce {
    display: inline-flex;
    align-items: center;
    gap: 7px;
  }
  i {
    display: inline-block;
    flex-shrink: 0;
    width: 26px;
    height: 14px;
    border: 1px solid;
    border-radius: 4px;
  }
  i.tratteggio {
    border-style: dashed;
  }
  i.righe {
    background-image: repeating-linear-gradient(
      135deg,
      rgba(255, 255, 255, 0) 0 4px,
      rgba(255, 255, 255, 0.8) 4px 6px
    );
  }
`;

export const PannelloStile = styled.div`
  ${elementiComuni}
  ${lineaOraria}
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: ${C.testo};

  .naviga {
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }
  .sezione {
    display: flex;
    flex-direction: column;
    gap: 9px;
  }
  .sezione h3 {
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    color: #3a4160;
  }
  .testa-sezione {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: baseline;
    gap: 10px;
  }
  .totale {
    font-size: 20px;
    font-weight: 700;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
  .totale span {
    font-size: 13px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .contratto {
    font-size: 12.5px;
    font-weight: 600;
    color: #4a5170;
  }
  .bandierine {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .mini {
    padding: 8px 8px 6px;
    border: 1px solid ${C.linea};
    border-radius: 10px;
  }
  .asse-mini {
    position: relative;
    height: 16px;
    font-size: 11px;
    font-weight: 700;
    color: ${C.testoSecondario};
    font-variant-numeric: tabular-nums;
  }
  .asse-mini span {
    position: absolute;
    transform: translateX(-50%);
  }
  .asse-mini span.prima {
    transform: none;
  }
  .asse-mini span.ultima {
    transform: translateX(-100%);
  }
  .scheda {
    display: flex;
    flex-direction: column;
    gap: 7px;
    padding: 10px 12px;
    border: 1px solid ${C.linea};
    border-radius: 10px;
  }
  .scheda.in-attesa {
    border-style: dashed;
    border-color: ${L.inAttesa.bordo};
  }
  .testa-scheda {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  /* schede richiudibili del pannello (turni, presenze, giustificativi) */
  button.testa-scheda {
    width: calc(100% + 16px);
    margin: -4px -8px;
    padding: 4px 8px;
    border: 0;
    border-radius: 7px;
    background: transparent;
    font: inherit;
    font-weight: 700;
    color: inherit;
    text-align: left;
    cursor: pointer;
  }
  button.testa-scheda:hover {
    background: #f4f5fa;
  }
  button.testa-scheda:focus-visible {
    outline: 2px solid ${BaseColor};
    outline-offset: 1px;
  }
  .titolo-scheda {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    min-width: 0;
  }
  .titolo-scheda .freccia {
    flex-shrink: 0;
    font-size: 11px;
    color: ${C.testoSecondario};
    transition: transform 0.15s;
  }
  .scheda.aperta .titolo-scheda .freccia {
    transform: rotate(90deg);
  }
  .pillole {
    display: inline-flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 6px;
  }
  .corpo-scheda {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }
  .corpo-scheda[hidden] {
    display: none;
  }
  @media (prefers-reduced-motion: reduce) {
    .titolo-scheda .freccia {
      transition: none;
    }
  }
  .giustificativo {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    font-size: 13.5px;
    font-weight: 600;
  }
  .meta {
    font-size: 12.5px;
    font-weight: 600;
    color: #4a5170;
  }
  .nota-dipendente {
    padding: 7px 10px;
    border-radius: 8px;
    background: ${C.fondoGruppo};
    font-size: 13px;
    font-weight: 500;
    color: #2a3050;
  }
  .dl {
    display: grid;
    grid-template-columns: 104px 1fr;
    gap: 5px 10px;
    margin: 0;
    font-size: 13px;
  }
  .dl dt {
    font-weight: 500;
    color: ${C.testoSecondario};
  }
  .dl dd {
    margin: 0;
    font-weight: 700;
    color: ${C.testo};
    font-variant-numeric: tabular-nums;
  }
  .storico {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .storico li {
    display: grid;
    grid-template-columns: 96px 1fr;
    gap: 8px;
    padding: 7px 0;
    border-bottom: 1px solid #f0f1f5;
    font-size: 13px;
  }
  .storico li:last-child {
    border-bottom: 0;
  }
  .storico .quando {
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .storico .cosa {
    font-weight: 600;
    color: #4a5170;
  }
  .storico .cosa b {
    color: ${C.testo};
  }
`;

/** Segnalazione da gestire: nel pannello e nelle righe di Da gestire. */
export const Segnalazione = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 11px 12px;
  border-radius: 10px;
  font-size: 13.5px;
  line-height: 1.4;

  &.anomalia {
    background: ${C.anomalia.fondo};
    color: #7e1830;
  }
  &.avviso {
    background: ${C.avviso.fondo};
    color: #6e4300;
  }
  .testa {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
  }
  .giorno {
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }
  .nota {
    font-size: 12.5px;
    font-weight: 600;
  }
`;

export const Pulsanti = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

/** Modulo in linea (orari, turno): sotto la segnalazione o la scheda della presenza. */
export const ModuloInLinea = styled.form`
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 10px;
  border: 1px solid ${C.linea};
  border-radius: 9px;
  background: #fff;
  color: ${C.testo};

  .campi {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 8px;
  }
  .ant-picker,
  .ant-select {
    width: 100%;
  }
  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12.5px;
    font-weight: 700;
    color: #3a4160;
  }
  .spiegazione {
    margin: 0;
    font-size: 12.5px;
    font-weight: 600;
    color: #4a5170;
  }
  .errore {
    margin: 0;
    font-size: 12.5px;
    font-weight: 700;
    color: ${C.anomalia.testo};
  }
`;

export const ListaDaGestire = styled.div`
  ${elementiComuni}
  overflow: auto;
  background: #fff;
  border: 1px solid ${C.linea};
  border-radius: 12px;

  .elenco {
    min-width: 980px;
  }
  .riga {
    display: grid;
    grid-template-columns: 44px 230px 200px minmax(240px, 1fr) minmax(280px, auto);
    align-items: center;
  }
  .riga.testata {
    position: sticky;
    z-index: 2;
    top: 0;
    background: #fff;
    border-bottom: 1px solid ${C.linea};
    font-size: 13px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .riga.testata > div {
    padding: 10px 12px;
  }
  .giorno {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 14px;
    background: ${C.fondoGruppo};
    border-bottom: 1px solid ${C.linea};
    font-size: 14px;
    font-weight: 700;
  }
  .riga.elemento {
    border-bottom: 1px solid ${C.lineaLeggera};
  }
  .riga.elemento.fatto {
    background: #f7fbf9;
  }
  .riga.elemento > div {
    padding: 10px 12px;
    min-width: 0;
  }
  .scelta {
    display: grid;
    place-items: center;
  }
  .chi {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .chi .testi {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  .chi .nome {
    overflow: hidden;
    font-weight: 700;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .chi .gruppo {
    overflow: hidden;
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .dettaglio {
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 13px;
    line-height: 1.4;
  }
  .dettaglio .nota {
    font-size: 12.5px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .azioni {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
  }
  .azioni > form {
    flex: 1 1 100%;
  }
  .esito {
    font-size: 13px;
    font-weight: 700;
  }
  .esito.ok {
    color: ${C.inLinea};
  }
  .esito.ko {
    color: ${C.anomalia.testo};
  }
  .modulo {
    grid-column: 2 / -1;
    padding: 0 12px 12px !important;
  }
  .vuoto {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 28px 20px;
  }
`;

export const BarraSelezione = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 12px;
  background: ${BaseColor};
  color: #fff;

  .nota {
    font-size: 12.5px;
    font-weight: 600;
    opacity: 0.9;
  }
`;

export const MeseStile = styled.div`
  ${elementiComuni}
  display: flex;
  flex-direction: column;
  gap: 14px;

  .persona {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .persona .nome {
    font-size: 17px;
    font-weight: 700;
  }
  .persona .gruppo {
    font-size: 13px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .mese {
    min-width: 150px;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
  }
  .contratto {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 10px;
    font-size: 13px;
    font-weight: 600;
    color: #4a5170;
  }
  .contratto b {
    color: ${C.testo};
  }
  .riepilogo {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 10px;
  }
  .riquadro {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 12px 14px;
    background: #fff;
    border: 1px solid ${C.linea};
    border-radius: 12px;
  }
  .riquadro .chiave {
    font-size: 12.5px;
    font-weight: 700;
    color: ${C.testoSecondario};
  }
  .riquadro .valore {
    font-size: 22px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .riquadro .valore span {
    font-size: 13px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .riquadro .nota {
    font-size: 12.5px;
    font-weight: 600;
    color: #4a5170;
  }
  .riquadro .nota.rosso {
    color: ${C.anomalia.testo};
  }
  .riquadro .barra {
    height: 5px;
    overflow: hidden;
    border-radius: 3px;
    background: ${C.barra.traccia};
  }
  .riquadro .barra span {
    display: block;
    height: 100%;
    background: ${C.barra.sotto};
  }
  .riquadro .barra span.piena {
    background: ${C.barra.inLinea};
  }
  .tabella {
    overflow: auto;
    background: #fff;
    border: 1px solid ${C.linea};
    border-radius: 12px;
  }
  table {
    width: 100%;
    min-width: 1080px;
    border-collapse: collapse;
    font-size: 13px;
  }
  th {
    position: sticky;
    z-index: 1;
    top: 0;
    padding: 10px 12px;
    background: #fff;
    border-bottom: 1px solid ${C.linea};
    font-weight: 600;
    color: ${C.testoSecondario};
    text-align: left;
    white-space: nowrap;
  }
  td {
    padding: 8px 12px;
    border-bottom: 1px solid ${C.lineaLeggera};
    vertical-align: middle;
  }
  .num {
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
  tr.oggi td {
    background: ${C.oggi};
  }
  tr.oggi td:first-child {
    box-shadow: inset 3px 0 0 ${BaseColor};
  }
  tr.non-previsto td {
    background: #fafbfc;
  }
  tr.festa td {
    background: ${C.festa.fondo};
  }
  tr.aperto td {
    background: #eef0fb;
  }
  tr.aperto td:first-child {
    box-shadow: inset 3px 0 0 ${BaseColor};
  }
  .nome-giorno {
    display: flex;
    flex-direction: column;
    font-weight: 700;
    white-space: nowrap;
  }
  .nome-giorno span {
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
    text-transform: capitalize;
  }
  .pillole {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }
  .giust {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 1px 8px;
    border: 1px solid;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }
  .giust.in-attesa {
    border-style: dashed;
  }
  .giust .pallino {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .barrato {
    text-decoration: line-through;
  }
  .scelta-persona {
    min-width: 260px;
  }
  .vuoto {
    padding: 28px 20px;
    background: #fff;
    border: 1px solid ${C.linea};
    border-radius: 12px;
  }
`;
